import axios from "axios";
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const useDeviceCheck = (deviceId) => {
  const navigate = useNavigate();
  const location = useLocation(); // ⭐ route tracker
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  useEffect(() => {
    if (!deviceId) return;

    const checkDevice = async () => {
      const token = localStorage.getItem("token");
      if (!token) return;

      try {
        await axios.get(`${API_BASE_URL}/subadmin/check-device`, {
          headers: {
            Authorization: `Bearer ${token}`,
            deviceid: deviceId,
          },
        });
      } catch (error) {
        // 🔥 superAdmin ne session hata diya
        localStorage.clear();
        navigate("/", { replace: true });
        alert("You've LoggedIn in other device ")
      }
    };

    checkDevice();
  }, [deviceId, location.pathname]); // ⭐ KEY LINE
};

export default useDeviceCheck;